"use client";

import { motion } from "framer-motion";
import { MonitorIcon, MoonStarIcon, SunIcon } from "lucide-react";
import { useTheme } from "next-themes";
import React from "react";
import { cn } from "@/lib/_utils";

const THEME_OPTIONS = [
  {
    icon: MonitorIcon,
    value: "system",
  },
  {
    icon: SunIcon,
    value: "light",
  },
  {
    icon: MoonStarIcon,
    value: "dark",
  },
];

export function ToggleTheme() {
  const { theme, setTheme } = useTheme();

  const [isMounted, setIsMounted] = React.useState(false);

  React.useEffect(() => {
    setIsMounted(true);
  }, []);

  if (!isMounted) {
    return <div className="flex h-8 w-24" />;
  }

  return (
    <motion.div
      animate={{ opacity: 1 }}
      className="inline-flex items-center overflow-hidden rounded-md border bg-muted/80"
      initial={{ opacity: 0 }}
      key={String(isMounted)}
      role="radiogroup"
      transition={{ duration: 0.3 }}
    >
      {THEME_OPTIONS.map((option) => (
        <button
          aria-label={`Switch to ${option.value} theme`}
          aria-pressed={theme === option.value}
          className={cn(
            "relative flex size-7 cursor-pointer items-center justify-center rounded-md transition-all",
            theme === option.value
              ? "text-foreground"
              : "text-muted-foreground hover:text-foreground"
          )}
          key={option.value}
          onClick={() => setTheme(option.value)}
          type="button"
        >
          {theme === option.value && (
            <motion.div
              className="absolute inset-0 rounded-md border border-muted-foreground/50"
              layoutId="theme-option"
              transition={{ type: "spring", bounce: 0.1, duration: 0.75 }}
            />
          )}
          <option.icon className="size-3.5" />
        </button>
      ))}
    </motion.div>
  );
}
